<template>
    <v-form ref="form">
        <v-row class="mt-4">
            <v-col cols="4" class="py-0">
                <MesInputMultiple
                    label="Período"
                    v-model="value.periodo"
                    :rules="regra.periodo"
                    :min="mesAnterior"
                    :readonly="value.fnEditar"
                    :disabled="value.fnEditar"
                    required
                    outlined
                />
            </v-col>
            <v-col cols="4" class="py-0">
                <v-text-field
                    label="Projeto"
                    v-model="value.projeto"
                    :rules="regra.projeto"
                    :disabled="value.fnLeitura"
                    outlined
                    class="input-cinza"
                    dense
                    required
                ></v-text-field>
            </v-col>
            <v-col cols="4" class="py-0">
                <SelectInput
                    label="Categoria"
                    v-model="value.categorias"
                    :items="lista.categorias"
                    :menu-props="menuProps"
                    :rules="regra.categoria"
                    :disabled="value.fnLeitura"
                    multiple
                    show-select-all
                    class="input-cinza"
                    outlined
                    dense
                >
                </SelectInput>
            </v-col>
            <v-col cols="4" class="py-0">
                <v-autocomplete
                    label="Espaço GC"
                    v-model="value.id_espaco_gc"
                    :items="lista.espacoGC"
                    :menu-props="menuProps"
                    :rules="regra.espacoGC"
                    :disabled="value.fnEditar"
                    @change="limpaFiliais()"
                    class="input-cinza"
                    outlined
                    dense
                >
                </v-autocomplete>
            </v-col>
            <v-col cols="12" class="py-0">
                <v-textarea
                    outlined
                    class="input-cinza"
                    v-model="value.obs_departamento"
                    dense
                    rows="3"
                    label="Observação Departamento"
                ></v-textarea>
            </v-col>

        </v-row>
        <v-overlay
            :value="semAcesso"
            :absolute="true"
            :opacity="0.1"
            :z-index="3"
        ></v-overlay>
    </v-form>
</template>

<script>
export default {
    inject: ["listaCampos"],
    props: ["value", "usuarioTipo"],
    data() {
        return {
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: "select-outline",
                transition: "slide-y-transition",
                zIndex: 9999,
            },
            lista: {
                espacoGC: [],
                categorias: [],
            },
            regra: {
                periodo: [
                    (v) => v.length > 0 || "O campo período é obrigatório",
                ],
                projeto: [
                    (v) => !!v || "O campo projeto é obrigatório",
                ],
                categoria: [
                    (v) => (!!v && v.length > 0) || "O campo categoria é obrigatório",
                ],
                espacoGC: [
                    (v) => !!v || "O campo espaço GC é obrigatório",
                ],
            },
            semAcesso: false,
        };
    },
    async created() {
        var lista = await this.listaCampos;
        this.lista.espacoGC = lista.espacoGC || [];
        this.lista.categorias = lista.categorias || [];
    },
    computed: {
        mesAtual() {
            return this.$moment().format("YYYY-MM");
        },
        mesAnterior() {
            return this.$moment().subtract(1, "month").format("YYYY-MM");
        },
    },
    methods: {
        limpaCadastro() {
            this.$emit("input", { ...this.value });
        },
        limpaFiliais() {
            this.$emit("limpaFiliais");
        },
        validate() {
            return this.$refs.form.validate();
        },
        reset() {
            return this.$refs.form.reset();
        },
        resetValidation() {
            try {
                this.$refs.form.resetValidation();
            } catch (error) {
                //console.log(error)
            }
        },
    },
};
</script>
